// extracted by mini-css-extract-plugin
export default {"milestoneWrapper":"milestone_milestoneWrapper__vPTTZ","milestoneBackground":"milestone_milestoneBackground__hiDH6"};